// removed by extract-text-webpack-plugin
module.exports = {"showLoadingAnimation":"FoodList__showLoadingAnimation__2xukA","react-placeholder-pulse":"FoodList__react-placeholder-pulse__2REeI","item":"FoodList__item__1BBK7","flexItem":"FoodList__flexItem__3KuKT","mostOrdered":"FoodList__mostOrdered__o3SB-","isBack":"FoodList__isBack__1i1cF"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/FoodList/FoodList.css
// module id = 303
// module chunks = 0